var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinkGcik(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 17,
    viewBox: "0 0 100 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23877 8.44507C2.23877 8.44507 7.58952 0.0495433 13.7462 8.44507C19.9029 16.8406 25.7686 8.44507 25.7686 8.44507C25.7686 8.44507 31.888 0.0495433 38.0597 8.44507C44.2313 16.8406 49.3283 8.44507 49.3283 8.44507C49.3283 8.44507 54.6492 0.0495433 60.8059 8.44507C66.9627 16.8406 74.2388 8.44507 74.2388 8.44507C74.2388 8.44507 80.3432 0.0495433 86.5 8.44507C92.6567 16.8406 97.7612 8.44507 97.7612 8.44507",
    stroke: "#F94171",
    strokeWidth: 3.73134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkGcik);
export default __webpack_public_path__ + "static/media/pinkGcik.02efe87a274ae648fc0c99aa4cf5d09c.svg";
export { ForwardRef as ReactComponent };